import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Store, Wand2, ShoppingBag, HelpCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";

const ITEMS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/shop", label: "Explore", icon: Store },
  { to: "/build", label: "Build", icon: Wand2 },
];

export const BottomNav = () => {
  const location = useLocation();
  const { count, setIsOpen } = useCart();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 md:hidden" data-testid="mobile-bottom-nav">
      <div className="glass-strong mx-3 mb-3 flex items-center justify-around rounded-wp-xl border border-border px-2 py-2 shadow-wp-lift">
        {ITEMS.map(({ to, label, icon: Icon }) => {
          const active = location.pathname === to;
          return (
            <Link key={to} to={to} data-testid={`bottomnav-${label.toLowerCase()}`}
              className={`flex flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 text-[11px] font-medium transition-colors ${active ? "text-wp-rose-strong" : "text-wp-ink-muted"}`}>
              <Icon className={`h-5 w-5 ${active ? "text-wp-rose-strong" : ""}`} />
              {label}
            </Link>
          );
        })}
        <button onClick={() => window.dispatchEvent(new Event("wp-open-concierge"))} data-testid="bottomnav-help"
          className="flex flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 text-[11px] font-medium text-wp-ink-muted">
          <HelpCircle className="h-5 w-5" />
          Help
        </button>
        <button onClick={() => setIsOpen(true)} data-testid="bottomnav-cart"
          className="relative flex flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 text-[11px] font-medium text-wp-ink-muted">
          <ShoppingBag className="h-5 w-5" />
          Cart
          {count > 0 && <span className="absolute right-1 top-0 grid h-4 min-w-4 place-items-center rounded-full bg-wp-rose-strong px-1 text-[9px] text-white">{count}</span>}
        </button>
      </div>
    </nav>
  );
};
